import React from 'react'

const HeadingPage = ({ pageHeading, buttons }) => {
    return (
        <section className='heading-page'>
            <div>
                <h2 className='exado-subTitle-one'>{pageHeading}</h2>
            </div>
            <div>
                {buttons}
            </div>
        </section>
    )
}

export default HeadingPage
